module.exports = __webpack_public_path__ + "media/images/icon__backArrow-7afe2b38087401b5d64e281504b786ba.svg";